export const ONBOARDING_AGENT_QUICK_ACTION_TYPE = {
    navigate: "navigate",
    action: "action",
} as const;

export type OnboardingAgentQuickActionType =
    (typeof ONBOARDING_AGENT_QUICK_ACTION_TYPE)[keyof typeof ONBOARDING_AGENT_QUICK_ACTION_TYPE];

export type OnboardingAgentSuggestedPage = {
    readonly title: string;
    readonly link: string;
    readonly uiRouterState: string;
};

export type OnboardingAgentQuickAction = {
    readonly label: string;
    readonly type: string;
    readonly target: string;
};

export type OnboardingAgentRequestPayload = {
    readonly url: string;
    readonly message: string;
    readonly threadId?: string | null;
};

export type OnboardingAgentResponse = {
    readonly threadId: string;
    readonly responseText: string;
    readonly suggestedPages: readonly OnboardingAgentSuggestedPage[];
    readonly followUpQuestions: readonly string[];
    readonly quickActions: readonly OnboardingAgentQuickAction[];
    readonly suggestedActions: readonly string[];
};
